import React from "react"
import { useTranslation } from "react-i18next"
import { CleanHtml, merchantSelectors, useProviderForPaymentTypeWhenDataLoaded, useSelector } from "swiipe.portal.shared"
import { useRequiredUserRelations } from "../../services/userRelationService"
import PiqVippsOnboardingPageInner from "./PiqVippsOnboardingPageInner"
import "./VippsOnboardingPage.scss"
import { IVippsOnboardingPageProps } from "./VippsProps"
import VmpVippsOnboardingPageInner from "./VmpVippsOnboardingPageInner"

const VippsOnboardingPage = (props: IVippsOnboardingPageProps) => {
    useRequiredUserRelations([{ requiredType: "Merchant" }])
    const merchantDetails = useSelector(merchantSelectors.merchantDetails)
    const selectedWebshopId =
        props.webshopIds && props.webshopIds?.length > 0 ? props.webshopIds[0] : useSelector(merchantSelectors.selectedWebshopId)

    const vippsProvider = useProviderForPaymentTypeWhenDataLoaded("Vipps", selectedWebshopId)
    if (!merchantDetails || !merchantDetails.webshops.length || !vippsProvider) {
        return null
    }

    if (vippsProvider === "PaymentIQ") {
        return (
            <PiqVippsOnboardingPageInner
                merchantDetails={merchantDetails}
                selectedWebshopId={selectedWebshopId}
                guideContent={<VippsGuideContent />}
                {...props}
            ></PiqVippsOnboardingPageInner>
        )
    }

    return (
        <VmpVippsOnboardingPageInner
            merchantDetails={merchantDetails}
            selectedWebshopId={selectedWebshopId}
            guideContent={<VippsGuideContent />}
            {...props}
        ></VmpVippsOnboardingPageInner>
    )
}

const VippsGuideContent = () => {
    const { t } = useTranslation()
    return (
        <div className="vipps-onboarding__hint-container">
            <p>{t("vippsonboarding.vippsGuideContext")}</p>
            <ol className="vipps-onboarding__guide-steps">
                <CleanHtml element="li" html={t("vippsonboarding.vippsGuideStep1")} />
                <li>{t("vippsonboarding.vippsGuideStep2")}</li>
                <li>{t("vippsonboarding.vippsGuideStep3")}</li>
            </ol>
            <a
                className="vipps-onboarding__guide-link"
                href="https://developer.vippsmobilepay.com/docs/knowledge-base/api-keys/"
                target="_blank"
                rel="noreferrer"
            >
                {t("vippsonboarding.seeTheFullGuide")}
            </a>
        </div>
    )
}

export default VippsOnboardingPage
